import { NewAdvancedSearch } from '../components/inventory/new-advanced-search-hybrid.vue';
Vue.component('new-advanced-search', NewAdvancedSearch);